import { render } from "./category-attributes-config.vue?vue&type=template&id=bb16a360&scoped=true"
import script from "./category-attributes-config.vue?vue&type=script&lang=js"
export * from "./category-attributes-config.vue?vue&type=script&lang=js"

import "./category-attributes-config.vue?vue&type=style&index=0&id=bb16a360&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb16a360"]])

export default __exports__